<template>
	<section>
		<div>
			<o-tabs v-model="activeTab">
				<o-tab-item value="tags" label="Tags">
					<o-inputitems
						v-model="tags"
						:data="filteredTags"
						field="Title"
						autocomplete
						:open-on-focus="true"
						icon="tag"
						placeholder="Add a tag"
						@typing="FilterTags"
						@add="UpdateModel"
						@remove="UpdateModel"></o-inputitems>
				</o-tab-item>
				<o-tab-item value="search" label="Search">
					<o-input v-model="search" @input="UpdateModel" icon-left="search" placeholder="Seach" />
				</o-tab-item>
			</o-tabs>
		</div>
	</section>
</template>
<script>
	import { onMounted, ref, inject, watch } from "vue";

	export default {
		props: {
			modelValue: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		emits: ["update:modelValue"],
		setup(props, context) {
			const $http = inject("$http");
			const activeTab = ref("tags");
			const data = ref([]);
			const filteredTags = ref(data.value);
			const tags = ref(props.modelValue.tags);
			const search = ref(props.modelValue.search);
			const model = ref(props.modelValue);

			if (search.value) activeTab.value = "search";
			if (tags.value && tags.value.length > 0) activeTab.value = "tags";

			function FilterTags(text) {
				filteredTags.value = data.value.filter((option) => {
					return option.Title.toLowerCase().indexOf(text.toLowerCase()) >= 0;
				});
			}

			function UpdateModel() {
				model.value.tags = tags.value;
				model.value.search = search.value;
				context.emit("update:modelValue", model.value);
			}

			async function GetTags() {
				const response = await $http.get("/api/v2/cms/tags");
				data.value = response.data;
			}

			watch(
				() => props.modelValue,
				(n) => {
					tags.value = n.tags;
					search.value = n.search;
				},
				{ deep: true }
			);

			onMounted(async () => {
				await GetTags();
				filteredTags.value = data.value;
			});

			return { activeTab, filteredTags, tags, search, FilterTags, UpdateModel };
		}
	};
</script>
